class Config {
  getConfig(): {
    backend: {
      url: string;
    };
    sentry: {
      dsn: string;
      sessionReplay: boolean;
      environment: string;
    };
  } {
    return (process.env.APP_CONFIG as any) || {};
  }
}

export default new Config();
